import {
	SET_USER_INFO,
	SET_USER_TOKEN,
	LOGOUT_USER,
	SET_PAGE_TITLE,
	SET_MENU_OPEN,
	SET_MENU_EXPANDED,
	SET_LAST_MENU_ITEM_OPEN_ID,
	SET_APP_NAME,
	SET_USER_READY,
	CLEAR_LOCAL_STORAGE,
	SET_MENU_RESULTS,
	SET_PROFILE_MENU_RESULTS,
	SET_COMPANIES_RESULTS,
	COMPANIES_RESULTS_KEY,
	SET_FAVORITES,
	SET_MENU_RESULTS_STORAGE,
	SET_MAIN_ITEM_CLICKED,
	SET_LAST_ITEM_CLICKED,
	SET_NOTIFICATION_MODAL_CONTENT,
	SET_NOTIFICATION_MODAL_VISIBLE,
	SET_ACTIVE_NOTIFICATIONS,
	SET_DISMISSED_NOTIFICATIONS,
	SET_UNSHOWN_NOTIFICATIONS,
	REMOVE_SHOWN_NOTIFICATIONS,
	REMOVE_FROM_ACTIVE_NOTIFICATIONS,
	ADD_UNSHOWN_ALERT,
	ADD_TO_ACTIVE_NOTIFICATIONS,
	ADD_TO_DISMISSED_NOTIFICATIONS,
	SET_PAGE_VERSION_CONFIGKEY_ID,
	SET_REQUEST_VERIFICATION_TOKEN,
	SET_IFRAME_SOURCE,
	SET_CURRENT_COMPANY_ID,
	SET_CURRENT_ROUTE_MENU_ID,
	SET_LAST_MAIN_ITEM_CLICKED,
	SET_APP_CONFIGS,
	SET_ZONE_WARNING,
	SET_AUTOLOGOFF_STATUS,
	CLEAR_NOTIFICATIONS
} from './vuser-mutation-types';
import apiService from '@/services/api-service';
import userApiService from '@/services/user-api-service';
import vueApiService from '@/services/accessweb-api-service';
import Vue2Storage from 'vue2-storage';
import buildRoute from '@/composables/build-route';
import gatherItems from '@/utils/gather-items';
import { simulateIsoDate } from '@/utils/date-functions';
import Vue from 'vue';
import cookies from 'vue-cookies';
import store from '@/store/index.js';
import vueResetProp from '@/utils/vue-reset-prop';
import { AutoLogoffManager } from '@/store/modules/vuser/vuser-plugins';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'user',
	namespaced: true,
	state: {
		userInfo: null,
		userToken: null,
		requestVerificationToken: null,
		baseUrl: process.env.VUE_APP_API,
		authServerUrl: process.env.VUE_APP_AUTH_SERVER,
		accessWebUrl: process.env.VUE_APP_ACCESSWEB_URL,
		vueAppBase: process.env.VUE_APP_BASE || '',
		vueAppSitePath: process.env.VUE_APP_SITE_PATH,
		accessWebPageViewerUrl: '/System/PageViewer',
		pageTitle: '',
		isMenuOpen: false,
		isMenuExpanded: false,
		lastMenuItemOpen: [],
		appName: process.env.VUE_APP_NAME,
		userReady: false,
		initialized: false,
		localStorage: new Vue2Storage({
			prefix: 'vuelayout_',
			driver: 'local',
			ttl: 60 * 60 * 1000 // 1 hour
		}),
		logOffExpireTimeout: 60 * 60 * 1000, // 1 hour for AutoLogOff
		lastUserActivity: undefined,
		intervalcontextLocalStorage: 1000 * 5, // 5 seconds to capture a new Activity
		menuResults: undefined,
		profileMenuResults: {},
		companiesResults: undefined,
		icons: {},
		menuResultsStorageKeyPrefix: 'menuResults',
		mainItemClicked: {},
		version: 1,
		lastItemClicked: {},
		notificationModalContent: undefined,
		notificationModalVisible: false,
		activeNotificationPages: {},
		dismissedNotificationPages: {},
		unShownNotificationItems: [],
		pageVersionConfigKeyId: 0,
		iframeSource: null,
		router: {},
		currentCompanyId: -1,
		currentRouteMenuId: 0,
		lastMainItemClicked: 0,
		zoneWarning: null,

		//the default values are being set in the from .env when app builds
		//but in main.js, we call an api on AccessWeb to get these configs
		//and call the action to set them
		VUE_APP_API: process.env.VUE_APP_API,
		VUE_APP_AUTH_SERVER: process.env.VUE_APP_AUTH_SERVER,
		VUE_APP_NAME: process.env.VUE_APP_NAME,
		VUE_APP_SIGNALR_CONNECTION: process.env.VUE_APP_SIGNALR_CONNECTION,
		VUE_APP_ACCESSWEB_URL: process.env.VUE_APP_ACCESSWEB_URL
	},
	mutations: {
		[CLEAR_NOTIFICATIONS](state) {
			state.activeNotificationPages = {};
			state.dismissedNotificationPages = {};
			state.unShownNotificationItems = [];
		},
		[SET_MENU_OPEN](state, menuState) {
			state.isMenuOpen = menuState;
		},
		[SET_MENU_EXPANDED](state, newMenuState) {
			state.isMenuExpanded = newMenuState;
		},
		[SET_LAST_MENU_ITEM_OPEN_ID](state, lastId) {
			const idIndex = state.lastMenuItemOpen.indexOf(lastId);
			if (idIndex !== -1) {
				const removedId = state.lastMenuItemOpen[idIndex];
				state.lastMenuItemOpen.splice(idIndex, 1);
				state.lastMenuItemOpen.push(removedId);
			} else {
				state.lastMenuItemOpen.push(lastId);
			}
		},
		[SET_USER_INFO](state, userInfo) {
			state.userInfo = userInfo;
		},
		[SET_USER_TOKEN](state, userToken) {
			state.userToken = userToken;
		},
		[LOGOUT_USER](state) {
			state.userInfo = null;
			state.userToken = null;
			state.userReady = false;
			state.lastUserActivity = undefined;
		},
		[SET_PAGE_TITLE](state, pageTitle) {
			state.pageTitle = pageTitle;
		},
		[SET_APP_NAME](state, appName) {
			state.appName = appName;
		},
		[SET_USER_READY](state, userReady) {
			state.userReady = userReady;
		},
		[CLEAR_LOCAL_STORAGE](state) {
			if (state.localStorage != undefined) {
				state.localStorage.clear();
			}
		},
		[SET_MENU_RESULTS](state, menuResults) {
			state.menuResults = menuResults;
		},
		[SET_MENU_RESULTS_STORAGE](state, { menuResults, key }) {
			state.localStorage.set(key, menuResults);
		},
		[SET_PROFILE_MENU_RESULTS](state, { profileMenuResults }) {
			state.profileMenuResults = profileMenuResults;
		},
		[SET_COMPANIES_RESULTS](state, { companiesResults, key }) {
			state.companiesResults = companiesResults;
			state.localStorage.set(key, companiesResults);
		},
		addIconClass(state, { text, iconClass }) {
			state.icons[text] = iconClass;
			//console.log(JSON.stringify(state.icons));
		},
		[SET_FAVORITES](state, favoritesCollection) {
			let favoritesIndex = state.menuResults.childItems.findIndex(
				menu => menu.itemText == 'Favorites'
			);

			state.menuResults.childItems.splice(
				favoritesIndex,
				1,
				favoritesCollection
			);
		},
		[SET_MAIN_ITEM_CLICKED](state, menuItem) {
			state.mainItemClicked = menuItem;
			cookies.set('mainItemClickedId', menuItem);
		},
		[SET_LAST_MAIN_ITEM_CLICKED](state, menuItem) {
			state.lastMainItemClicked = menuItem;
			// cookies.set('lastMainItemClicked', menuItem);
		},
		[SET_LAST_ITEM_CLICKED](state, menuItem) {
			state.lastItemClicked = menuItem;
		},
		[SET_NOTIFICATION_MODAL_CONTENT](state, content) {
			state.notificationModalContent = content;
		},
		[SET_NOTIFICATION_MODAL_VISIBLE](state, visible) {
			state.notificationModalVisible = visible;
		},
		[SET_ACTIVE_NOTIFICATIONS](state, notifications) {
			Vue.set(
				state.activeNotificationPages,
				notifications.page + '',
				notifications
			);
		},
		[SET_DISMISSED_NOTIFICATIONS](state, notifications) {
			Vue.set(
				state.dismissedNotificationPages,
				notifications.page + '',
				notifications
			);
		},
		[SET_UNSHOWN_NOTIFICATIONS](state, notifications) {
			if (
				notifications &&
				notifications.items &&
				notifications.items.length > 0
			) {
				state.unShownNotificationItems.push(...notifications.items);
			}
		},
		[REMOVE_SHOWN_NOTIFICATIONS](state, ids) {
			for (let index = 0; index < ids.length; index++) {
				const idToRemove = ids[index];
				const removeAtIndex = state.unShownNotificationItems.findIndex(
					n => n.id === idToRemove
				);

				if (removeAtIndex >= 0) {
					state.unShownNotificationItems.splice(removeAtIndex, 1);
				}
			}
		},
		[REMOVE_FROM_ACTIVE_NOTIFICATIONS](state, notice) {
			for (const page in state.activeNotificationPages) {
				const index = state.activeNotificationPages[
					page
				].items.findIndex(n => n.id === notice.id);
				if (index >= 0) {
					state.activeNotificationPages[page].items.splice(index, 1);
					state.activeNotificationPages['1'].totalCount -= 1;

					//for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
					//vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
					//bug 81109
					vueResetProp(Vue, state.activeNotificationPages, page);

					if (page !== '1') {
						vueResetProp(Vue, state.activeNotificationPages, '1');
					}

					break;
				}
			}
		},
		[ADD_UNSHOWN_ALERT](state, alert) {
			let len = 0;

			if (state.unShownNotificationItems) {
				len = state.unShownNotificationItems.length;
			}

			state.unShownNotificationItems.splice(len, 0, alert);
		},
		[ADD_TO_ACTIVE_NOTIFICATIONS](state, alert) {
			if (!state.activeNotificationPages) {
				state.activeNotificationPages = {};
			}

			if (!state.activeNotificationPages['1']) {
				Vue.set(state.activeNotificationPages, '1', {
					items: [],
					totalCount: 0
				});
			}
			alert.dismissed = false;
			alert.shown = true;
			state.activeNotificationPages['1'].items.splice(0, 0, alert);
			state.activeNotificationPages['1'].totalCount += 1;

			//for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
			//vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
			//bug 81109
			vueResetProp(Vue, state.activeNotificationPages, '1');
		},
		[ADD_TO_DISMISSED_NOTIFICATIONS](state, alert) {
			if (!state.dismissedNotificationPages) {
				state.dismissedNotificationPages = {};
			}

			if (!state.dismissedNotificationPages['1']) {
				Vue.set(state.dismissedNotificationPages, '1', {
					items: [],
					totalCount: 0
				});
			}

			if (state.dismissedNotificationPages['1'].items) {
				alert.dismissedOn = simulateIsoDate(new Date());
				alert.dismissed = true;
				alert.shown = true;
				if (
					state.dismissedNotificationPages['1'].items.findIndex(
						n => n.id == alert.id
					) < 0
				) {
					state.dismissedNotificationPages['1'].items.splice(
						0,
						0,
						alert
					);
					state.dismissedNotificationPages['1'].totalCount += 1;

					//for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
					//vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
					//bug 81109
					vueResetProp(Vue, state.dismissedNotificationPages, '1');
				}
			}
		},
		[SET_PAGE_VERSION_CONFIGKEY_ID](state, id) {
			state.pageVersionConfigKeyId = id;
		},
		[SET_REQUEST_VERIFICATION_TOKEN](state, token) {
			state.requestVerificationToken = token;
		},
		[SET_IFRAME_SOURCE](state, iframeSource) {
			state.iframeSource = iframeSource;
		},
		[SET_CURRENT_COMPANY_ID](state, currentCompanyId) {
			state.currentCompanyId = currentCompanyId;
		},
		[SET_CURRENT_ROUTE_MENU_ID](state, id) {
			state.currentRouteMenuId = id;
			cookies.set('currentRouteMenuId', state.currentRouteMenuId);
		},
		[SET_APP_CONFIGS](state, appConfigs) {
			Object.assign(state, appConfigs);
			state.baseUrl = appConfigs.VUE_APP_API;
			state.authServerUrl = appConfigs.VUE_APP_AUTH_SERVER;
			state.accessWebUrl = appConfigs.VUE_APP_ACCESSWEB_URL;
			state.vueAppSitePath = appConfigs.VUE_APP_SITE_PATH;
			const timeoutSetting =
				appConfigs.VUE_APP_AUTOLOGOFF_TIMEOUT || 60 * 60 * 1000; // 1 hour for AutoLogOff
			state.logOffExpireTimeout = parseInt(timeoutSetting);
		},
		[SET_ZONE_WARNING](state, zoneWarning) {
			state.zoneWarning = zoneWarning;
		},
		[SET_AUTOLOGOFF_STATUS](state, enabled) {
			AutoLogoffManager.isEnabled = enabled;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async getUserInfoAction({ commit }, cache) {
			const parameters = { cache: cache !== false };
			const userInfo = await userApiService.get(
				buildRoute('/connect/userinfo?cache={cache}', parameters)
			);
			commit(SET_USER_INFO, userInfo);
			commit(SET_USER_READY, true);
		},
		setTokenAction({ commit }, userToken) {
			commit(SET_USER_TOKEN, userToken);
		},
		logoutUserAction({ commit }) {
			commit(LOGOUT_USER);
			commit(CLEAR_LOCAL_STORAGE);
		},
		setPageTitleAction({ commit }, pageTitle) {
			commit(SET_PAGE_TITLE, pageTitle);
		},
		setAppNameAction({ commit }, appName) {
			commit(SET_APP_NAME, appName);
		},
		setMenuIsOpen({ commit }, menuState) {
			commit(SET_MENU_OPEN, menuState);
		},
		setMenuIsExpanded({ commit }, menuState) {
			commit(SET_MENU_EXPANDED, menuState);
		},
		setLastMenuItemOpenId({ commit }, lastId) {
			commit(SET_LAST_MENU_ITEM_OPEN_ID, lastId);
		},
		//use this if the parent app is getting the oidc user info
		setUserInfoAction({ commit }, userInfo) {
			commit(SET_USER_INFO, userInfo);
			commit(SET_USER_READY, true);
		},
		setUserReady({ commit }, userReady) {
			commit(SET_USER_READY, userReady);
		},
		async getMenuResultsAction({ commit, getters, state }, companyId) {
			const varyParameters = { companyId: companyId };
			const key = getters.menuResultsStorageKey(companyId);
			let menuResults = state.localStorage.get(key);

			if (menuResults == undefined) {
				menuResults = await apiService.get(
					buildRoute('/menu/company/{companyId}', varyParameters)
				);
			}

			commit(SET_MENU_RESULTS, menuResults);
			commit(SET_MENU_RESULTS_STORAGE, { menuResults, key });
		},
		async getProfileMenuResultsAction({ commit }) {
			const varyParameters = { requestPath: window.location.pathname };
			const profileMenuResults = await apiService.get(
				buildRoute(
					'/menu/profile?requestpath={requestPath}',
					varyParameters
				)
			);

			commit(SET_PROFILE_MENU_RESULTS, { profileMenuResults });
		},
		async getCompaniesAction({ commit, state }, companyId) {
			const varyParameters = { companyId: companyId };
			const key = `${COMPANIES_RESULTS_KEY}_${JSON.stringify(
				varyParameters
			)}`;
			let companiesResults = state.localStorage.get(key);

			if (companiesResults == undefined) {
				companiesResults = await apiService.get(
					buildRoute(
						'/dealership/company/{companyId}/companies',
						varyParameters
					)
				);
			}

			commit(SET_COMPANIES_RESULTS, { companiesResults, key });
		},
		clearStateAction({ commit }) {
			commit(CLEAR_LOCAL_STORAGE, true);
		},
		setIconClass({ commit }, menuItem) {
			const text = menuItem.itemText;
			const iconClass = `icon-${menuItem.itemText
				.toLowerCase()
				.replace(' ', '-')}`;
			commit('addIconClass', { text, iconClass });
		},
		async addToFavoritesAction(
			{ commit, getters, state },
			{ menuItem, companyId }
		) {
			const key = getters.menuResultsStorageKey(companyId);
			const favoritesCollection = await apiService.post(
				buildRoute('/menu/company/{companyId}/favorites', {
					companyId: companyId
				}),
				menuItem
			);

			commit(SET_FAVORITES, favoritesCollection);
			commit(SET_MENU_RESULTS_STORAGE, {
				menuResults: state.menuResults,
				key: key
			});
		},
		async removeFromFavoritesAction(
			{ commit, getters, state },
			{ menuItem, companyId }
		) {
			const key = getters.menuResultsStorageKey(companyId);
			const favoritesCollection = await apiService.delete(
				buildRoute(
					'/menu/company/{companyId}/favorites?itemText={itemText}&itemValue={itemValue}',
					{
						companyId: companyId,
						itemText: menuItem.itemText,
						itemValue: menuItem.itemValue
					}
				)
			);
			commit(SET_FAVORITES, favoritesCollection);
			commit(SET_MENU_RESULTS_STORAGE, {
				menuResults: state.menuResults,
				key: key
			});
		},
		async orderFavoritesAction(
			{ commit, getters, state },
			{ menuItem, companyId, order }
		) {
			const key = getters.menuResultsStorageKey(companyId);
			const updatedItem = { ...menuItem };

			updatedItem.order = order;

			const favoritesCollection = await apiService.put(
				buildRoute('/menu/company/{companyId}/favorites', {
					companyId: companyId
				}),
				updatedItem
			);

			commit(SET_FAVORITES, favoritesCollection);
			commit(SET_MENU_RESULTS_STORAGE, {
				menuResults: state.menuResults,
				key: key
			});
		},
		setMainItemClickedAction({ commit }, menuItem) {
			commit(SET_MAIN_ITEM_CLICKED, menuItem);
		},
		setLastMainItemClickedAction({ commit }, menuItem) {
			commit(SET_LAST_MAIN_ITEM_CLICKED, menuItem);
		},
		async switchVersionAction(
			// eslint-disable-next-line no-unused-vars
			{ commit },
			{ version, companyId, configurationKeyId, employeeId }
		) {
			const configModel = {
				companyId: companyId,
				entityId: employeeId,
				configurationKeyId: configurationKeyId,
				keyValue: version
			};

			await apiService.post(
				buildRoute(
					'/dealership/company/{companyId}/configurations/employee/{employeeId}/key/{configurationKeyId}',
					{
						companyId: companyId,
						employeeId: employeeId,
						configurationKeyId: configurationKeyId
					}
				),
				configModel
			);
		},
		setLastItemClickedAction({ commit }, menuItem) {
			commit(SET_LAST_ITEM_CLICKED, menuItem);
		},
		async getCustomerMessagingAction({ commit }, params) {
			const customerMessaging = await vueApiService.post(
				'/System/CustomerMessaging',
				params
			);
			commit(SET_NOTIFICATION_MODAL_CONTENT, customerMessaging);
		},
		showNotificationModalAction(
			{ commit, state },
			{ alertLinkType, args }
		) {
			const argsQuery = JSON.stringify(args);
			const argsEncoded = encodeURIComponent(argsQuery);
			const iframeSource = `${state.accessWebUrl}${state.accessWebPageViewerUrl}?alertLinkType=${alertLinkType}&args=${argsEncoded}`;
			commit(SET_IFRAME_SOURCE, iframeSource);
			commit(SET_NOTIFICATION_MODAL_VISIBLE, true);
		},
		hideNotificationModalAction({ commit }) {
			commit(SET_NOTIFICATION_MODAL_VISIBLE, false);
			commit(SET_IFRAME_SOURCE, null);
		},
		async getNotificationsAction(
			// eslint-disable-next-line no-unused-vars
			{ commit },
			{ companyId, page, pageSize, dismissed, shown }
		) {
			page = page || 1;

			let route = buildRoute(
				'/dealership/company/{companyId}/notifications/alerts?page={page}&countperpage={countperpage}',
				{
					companyId: companyId,
					page: page,
					countperpage: pageSize
				}
			);

			//bug-58875: proper handling of route query params when undefined...
			//NOTE: underlying sproc assumes if [Dismissed] column is NULL === false
			if (dismissed !== undefined) {
				route = buildRoute(route + '&dismissed={dismissed}', {
					dismissed: dismissed
				});
			}

			//bug-58875: proper handling of route query params when undefined...
			//NOTE: underlying sproc assumes if [Shown] column is NULL === false
			if (shown !== undefined) {
				route = buildRoute(route + '&shown={shown}', { shown: shown });
			}

			const notifications = await apiService.get(route);

			//Filter out notifications based upon the dismissal/shown flags...
			notifications.items = notifications.items
				.filter(n => {
					if (dismissed !== undefined) {
						return n.dismissed === dismissed;
					}
					return true;
				})
				.filter(n => {
					if (shown !== undefined) {
						return n.shown === shown;
					}
					return true;
				});

			//console.log({ route: route, notifications: notifications });

			return notifications;
		},
		async getActiveNotificationsAction(
			{ commit, dispatch },
			{ companyId, page, pageSize }
		) {
			page = page || 1;

			//Pre-sorted/filtered from dispatch by dismissed/created [ASC/DESC] (see above)...
			const notifications = await dispatch('getNotificationsAction', {
				companyId: companyId,
				page: page,
				pageSize: pageSize,
				dismissed: false
				//, shown: true //bug-58875: old data may not have been shown but needs to appear in the list...
			});

			//Reinforce sort by created date (descending)...
			//Force the 'shown' flag to be true...
			notifications.items = notifications.items
				.sort((l, r) => {
					const ld = new Date(l.datetimeStamp);
					const rd = new Date(r.datetimeStamp);
					return rd - ld; //DESC - most recent first...
				})
				.map(n => {
					n.shown = true;
					return n;
				});

			commit(SET_ACTIVE_NOTIFICATIONS, notifications);
		},
		async getDismissedNotificationsAction(
			{ commit, dispatch },
			{ companyId, page, pageSize }
		) {
			page = page || 1;

			//Pre-sorted/filtered from dispatch by dismissed/created [ASC/DESC] (see above)...
			const notifications = await dispatch('getNotificationsAction', {
				companyId: companyId,
				page: page,
				pageSize: pageSize,
				dismissed: true
				//, shown: true //bug-58875: old data may not have been shown, but needs to appear in the list...
			});

			//Reinforce sort by dismissed date (descending)...
			//Force the 'shown' flag to be true...
			notifications.items = notifications.items
				.sort((l, r) => {
					const ld = new Date(l.datetimeStamp);
					const rd = new Date(r.datetimeStamp);
					return rd - ld; //DESC - most recent first...
				})
				.sort((l, r) => {
					const ld = new Date(l.dismissedOn); //NULL ~ 1/1/1970
					const rd = new Date(r.dismissedOn); //NULL ~ 1/1/1970
					return rd - ld; //DESC - then by most recently dismissed...
				})
				.map(n => {
					n.shown = true;
					return n;
				});

			commit(SET_DISMISSED_NOTIFICATIONS, notifications);
		},
		async getUnShownNotificationsAction({ commit, dispatch }, companyId) {
			const notifications = await dispatch('getNotificationsAction', {
				companyId: companyId,
				page: 1,
				pageSize: 100,
				shown: false //bug-58875: no longer care if it had been dismissed before or not...
			});

			//Reinforce sort by created date (descending)...
			//Force the 'shown' flag to be false...
			notifications.items = notifications.items
				.sort((l, r) => {
					const ld = new Date(l.datetimeStamp);
					const rd = new Date(r.datetimeStamp);
					return rd - ld; //DESC - most recent first...
				})
				.filter(n => {
					return n.shown === false;
				});

			commit(SET_UNSHOWN_NOTIFICATIONS, notifications);
		},
		async dismissNotificationAction(
			// eslint-disable-next-line no-unused-vars
			{ commit, state, getters },
			{ notification, companyId }
		) {
			const route = buildRoute(
				'/dealership/company/{companyId}/notifications/alerts/dismiss',
				{ companyId: companyId }
			);
			const params = { id: notification.id, save: notification.save };
			let mutations;

			apiService.post(route, params);

			commit(REMOVE_FROM_ACTIVE_NOTIFICATIONS, notification);
			mutations = [
				`user/${REMOVE_FROM_ACTIVE_NOTIFICATIONS}`,
				`user/${ADD_TO_DISMISSED_NOTIFICATIONS}`
			];

			await store.dispatch('hub/invokeHubMethodAction', {
				message: {
					mutations: mutations,
					ToUserIds: [getters.hubUserId],
					data: notification,
					excludeSenderConnection: true
				}
			});

			//Mutation moved down after signal R
			commit(ADD_TO_DISMISSED_NOTIFICATIONS, notification);
		},
		async alertsShownAction({ commit }, { notificationItems, companyId }) {
			const route = buildRoute(
				'/dealership/company/{companyId}/notifications/alerts/shown',
				{ companyId: companyId }
			);
			const ids = [];

			if (notificationItems && notificationItems.length > 0) {
				notificationItems.forEach(n => ids.push(n.id));
				commit(REMOVE_SHOWN_NOTIFICATIONS, ids);
				await apiService.post(route, { ids: ids });
			}
		},
		addAlertAction({ commit }, alert) {
			commit(ADD_UNSHOWN_ALERT, alert);
			commit(ADD_TO_ACTIVE_NOTIFICATIONS, alert);
		},
		setPageVersionConfigKeyIdAction({ commit }, id) {
			commit(SET_PAGE_VERSION_CONFIGKEY_ID, id);
		},
		setRequestVerificationTokenAction({ commit }, token) {
			commit(SET_REQUEST_VERIFICATION_TOKEN, token);
		},
		currentCompanyIdAction({ commit }, currentCompanyId) {
			commit(SET_CURRENT_COMPANY_ID, currentCompanyId);
		},
		setCurrentRouteMenuIdAction({ commit }, id) {
			commit(SET_CURRENT_ROUTE_MENU_ID, id);
		},
		setAppConfigsAction({ commit }, appConfigs) {
			commit(SET_APP_CONFIGS, appConfigs);
		},
		switchZoneAction(_, zone) {
			//if we are already on the correct zone, do nothing
			if (
				zone.Host.localeCompare(window.location.host, undefined, {
					sensitivity: 'accent'
				}) === 0
			)
				return null;

			// we set a delay of 1ms to let the current call stack clear before redirecting
			return new Promise(resolve => {
				setTimeout(() => {
					var current = new URL(window.location.href);
					current.host = zone.Host;
					window.location.href = current.href;
					resolve();
				}, 1);
			});
		},
		setZoneWarning({ commit }, warning) {
			if (
				warning.Host.localeCompare(window.location.host, undefined, {
					sensitivity: 'accent'
				}) === 0
			)
				return null;
			commit(SET_ZONE_WARNING, warning);
		},
		setAutoLogoffStatusAction({ commit }, enabled) {
			commit(SET_AUTOLOGOFF_STATUS, enabled);
		}
	},
	getters: {
		hubUserId: state => {
			let userId;

			if (state.userInfo) {
				userId = `${state.userInfo.AspNetCompaniesId}_${state.userInfo.EmployeeId}`;
			}

			return userId;
		},
		currentCompanyId: state => state.currentCompanyId,
		userInfo: state => state.userInfo,
		userInfoSlim: state => {
			const {
				DealershipGroupNumber,
				CurrentEmployeeCompanyId,
				EmployeeImage,
				Email,
				AspNetCompaniesId,
				FirstName,
				LastName,
				EmployeeId,
				sub
			} = state.userInfo;

			const firstOrDefault = value =>
				Array.isArray(value)
					? value[0]
					: typeof value === 'string'
					? value
					: null;

			return {
				DealershipGroupNumber,
				CurrentEmployeeCompanyId,
				EmployeeImage,
				Email: firstOrDefault(Email),
				AspNetCompaniesId,
				FirstName: firstOrDefault(FirstName),
				LastName: firstOrDefault(LastName),
				EmployeeId,
				sub
			};
		},
		permissions: state => state.userInfo.permissions,
		userToken: state => state.userToken,
		requestVerificationToken: state => state.requestVerificationToken,
		quickSearchDefault: state => {
			if (state.userInfo) {
				return state.userInfo[
					'CompanyConfigurations.QuickSearchDefault'
				];
			}
			return null;
		},
		userFirstName: state => {
			if (state.userInfo) {
				return state.userInfo.FirstName;
			}
			return null;
		},
		userLastName: state => {
			if (state.userInfo) {
				return state.userInfo.LastName;
			}
			return null;
		},
		employeeId: state => {
			if (state.userInfo && state.userInfo.EmployeeId) {
				return parseInt(state.userInfo.EmployeeId);
			}
			return null;
		},
		pageTitle: state => state.pageTitle,
		pageVersionConfigKeyId: state => state.pageVersionConfigKeyId,
		appName: state => state.appName,
		isMenuOpen: state => state.isMenuOpen,
		isMenuExpanded: state => state.isMenuExpanded,
		userReady: state => state.userReady,
		initialized: state => state.userReady && state.userToken,
		menuResults: state => state.menuResults,
		profileMenuResults: state => state.profileMenuResults,
		companiesResults: state => state.companiesResults,
		icons: state => state.icons,
		notificationModalContent: state => state.notificationModalContent,
		accessWebUrl: state => state.accessWebUrl,
		accessWebPageViewerUrl: state => state.accessWebPageViewerUrl,
		vueAppBase: state => state.vueAppBase,
		notificationModalVisible: state => state.notificationModalVisible,
		activeNotificationPages: state => state.activeNotificationPages,
		unShownNotificationPages: state => state.unShownNotificationPages,
		dismissedNotificationPages: state => state.dismissedNotificationPages,
		iframeSource: state => state.iframeSource,
		vueAppSitePath: state => state.vueAppSitePath,
		activeNotificationItems: state => {
			const items = gatherItems(state.activeNotificationPages);
			return items;
		},
		dismissedNotificationItems: state => {
			const items = gatherItems(state.dismissedNotificationPages);
			return items;
		},
		unShownNotificationItems: state => state.unShownNotificationItems,
		activeNotificationCount: state => {
			let count = 0;

			if (
				state.activeNotificationPages &&
				state.activeNotificationPages[1]
			) {
				count = state.activeNotificationPages[1].totalCount;
			}

			return count;
		},
		dismissedNotificationCount: state => {
			let count = 0;

			if (
				state.dismissedNotificationPages &&
				state.dismissedNotificationPages[1]
			) {
				count = state.dismissedNotificationPages[1].totalCount;
			}

			return count;
		},
		activeNotificationPageCount: state => {
			let count = 1;

			if (
				state.activeNotificationPages &&
				state.activeNotificationPages[1]
			) {
				count = state.activeNotificationPages[1].totalPageCount;
			}

			return count;
		},
		dismissedNotificationPageCount: state => {
			let count = 1;

			if (
				state.dismissedNotificationPages &&
				state.dismissedNotificationPages[1]
			) {
				count = state.dismissedNotificationPages[1].totalPageCount;
			}

			return count;
		},
		isFavorite: state => menuItem => {
			let isFav = false;
			const favorites = state.menuResults.childItems.find(
				el => el.itemText == 'Favorites'
			);

			if (favorites) {
				isFav =
					favorites.childItems.findIndex(
						el =>
							el.itemText == menuItem.itemText &&
							el.itemValue == menuItem.itemValue
					) >= 0;
			}

			return isFav;
		},
		menuResultsStorageKey: state => companyId => {
			const varyParameters = { companyId: companyId };
			const key = `${state.menuResultsStorageKeyPrefix}_${JSON.stringify(
				varyParameters
			)}`;
			return key;
		},
		mainItemClickedId: state => {
			let id = 0;

			if (state.mainItemClicked && state.mainItemClicked > 0) {
				id = state.mainItemClicked;
			} else {
				const cookieVal = cookies.get('mainItemClickedId');

				if (cookieVal) {
					id = parseInt(cookieVal);
				}
			}

			return id;
		},
		lastMainItemClickedId: state => {
			let id = 0;

			if (state.lastMainItemClicked && state.lastMainItemClicked > 0) {
				id = state.lastMainItemClicked;
			} else {
				// const cookieVal = cookies.get('lastMainItemClicked');
				// if (cookieVal) {
				// 	id = parseInt(cookieVal);
				// }
			}

			return id;
		},
		lastItemClickedId: state => {
			let id = 0;

			if (state.lastItemClicked) {
				id = state.lastItemClicked.id;
			}

			return id;
		},
		currentRouteMenuId: state => {
			let id = 0;

			if (state.currentRouteMenuId && state.currentRouteMenuId > 0) {
				id = state.currentRouteMenuId;
			} else {
				const cookieVal = cookies.get('currentRouteMenuId');

				if (cookieVal) {
					id = parseInt(cookieVal);
				}
			}

			return id;
		},
		zoneWarning: state => state.zoneWarning,
		VUE_APP_API: state => state.VUE_APP_API,
		VUE_APP_AUTH_SERVER: state => state.VUE_APP_AUTH_SERVER,
		VUE_APP_NAME: state => state.VUE_APP_NAME,
		VUE_APP_BASE: state => state.VUE_APP_BASE,
		VUE_APP_SIGNALR_CONNECTION: state => state.VUE_APP_SIGNALR_CONNECTION,
		VUE_APP_ACCESSWEB_URL: state => state.VUE_APP_ACCESSWEB_URL
	}
};
